import { Link } from 'react-router-dom';

const NoticeCard = ({ notice, showViewMore = true }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Truncate description to show only first 100 characters
  const truncatedDescription = notice.description?.length > 100 
    ? notice.description.substring(0, 100) + '...' 
    : notice.description;

  return (
    <div className="bg-white rounded-lg shadow-md p-6 border-l-4 border-primary hover:shadow-lg transition-shadow duration-300">
      <div className="flex justify-between items-start mb-3">
        <h3 className="text-lg font-semibold text-gray-800 line-clamp-2">{notice.title}</h3>
        <span className={`ml-3 px-2 py-1 rounded text-xs font-medium ${
          notice.priority === 'Urgent' 
            ? 'bg-red-100 text-red-800' 
            : notice.priority === 'Important' 
              ? 'bg-yellow-100 text-yellow-800' 
              : 'bg-green-100 text-green-800'
        }`}>
          {notice.priority}
        </span>
      </div>
      
      <p className="text-gray-600 text-sm mb-4 line-clamp-3">
        {truncatedDescription}
      </p>
      
      <div className="flex justify-between items-center text-xs text-gray-500">
        <div>
          <span className="font-medium">By:</span> {notice.publishedBy?.name || notice.publishedBy || 'Admin'}
        </div>
        <div>
          <span className="font-medium">Published:</span> {formatDate(notice.createdAt)}
        </div>
      </div>
      
      <div className="flex justify-between items-center mt-4 pt-3 border-t">
        <div className="flex items-center text-xs text-gray-500">
          <span className="mr-2">👁️</span> {notice.views || 0} views
        </div>
        
        {showViewMore && (
          <Link 
            to={`/notices/${notice._id}`}
            className="text-primary hover:text-blue-700 text-sm font-medium"
          >
            Read More →
          </Link>
        )}
      </div>
    </div>
  );
};

export default NoticeCard;